import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import AuthenticatedRoute from './AuthenticatedRoute';
import Library from '../features/library';
import SelectedVideo from '../features/selectedVideo';
import Error from '../features/app/error';
import Settings from '../features/settings';
import SignUp from '../features/auth/SignUp';
import SignIn from '../features/auth/SignIn';
import ForgotPassword from '../features/auth/ForgotPassword';
import ResetPassword from '../features/auth/ResetPassword';
import DefaultRoute from '../features/app/DefaultRoute';
import Signout from '../features/auth/Signout';
import Loader from '../features/app/loader/LoaderFullScreen';
import RecorderDemo from '../recorder/Demo';
import UpgradeView from '../features/plan/upgrade/upgradeView';
import UpgradeStatus from '../features/plan/upgrade/upgradeStatus';
import SharedVideo from '../features/sharedVideo';
import MicroTool from '../features/microtools';
import Redirect from '../features/app/RedirectToLegacy';
import SearchPage from '../features/search';
import ContactSalesPage from '../features/sales/ContactSalesPage';

/**
 * TODO
 * /recover
 * recording request: /recording/for/:id
 * recording request expired: /expired-request
 * shared request: /shared/:shareId
 * emailverify
 * emailroute
 *
 */

const AppRoutes = () => {
  return (
    <HashRouter>
      <Routes>
        {/* All authenticated routes will render after fetching initial data */}
        <Route element={<AuthenticatedRoute />}>
          <Route index element={<DefaultRoute />} />
          <Route path="library">
            <Route index element={<Library />} />
            <Route path=":teamId/:folderId" element={<Library />} />
            <Route
              path=":teamId/:folderId/:fileId"
              element={<SelectedVideo />}
            />
          </Route>
          <Route path="search" element={<SearchPage />} />
          <Route path="settings/:settingKey" element={<Settings />} />
          <Route path="dashboard" element={<DefaultRoute />} />
        </Route>
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signout" element={<Signout />} />
        <Route path="/password/reset" element={<ResetPassword />} />
        <Route path="/password/forgot" element={<ForgotPassword />} />
        <Route path="/error" element={<Error />} />
        <Route path="/loader" element={<Loader />} />
        <Route path="/recorder" element={<RecorderDemo />} />
        <Route path="/billing/status" element={<UpgradeStatus />} />
        <Route path="/billing" element={<UpgradeView />} />
        <Route path="/contact-sales" element={<ContactSalesPage />} />
        {/* Public tools and shared content */}
        <Route path="/shared/:shareId" element={<SharedVideo />} />
        <Route path="/tool" element={<MicroTool />} />
        <Route path="/tool/:toolName" element={<MicroTool />} />
        <Route path="/emailroute" element={<Redirect />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </HashRouter>
  );
};

export default AppRoutes;
